// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b9b7c03b","455":"2c4ad64f","977":"9e1ab081"}[chunkId] + ".chunk.js";
};